import React, { useState } from 'react';
import Proptypes           from 'prop-types'
import AnimateHeight       from 'react-animate-height';

import DeleteIco from 'images/products/project_quote/close-ico.svg'

const InfoFabrication = ({ showSummary }) => {
  const [height, setHeight] = useState('auto')

  if (showSummary) return null;

  const toggleHeight = () => setHeight(height === 10 ? 'auto' : 10)

  return (
    <div className="info-message">
      <div className="pull-right close-action">
        <img src={DeleteIco} alt="delete" className="delete-ico" onClick={toggleHeight} />
      </div>
      <div className="content">
        <AnimateHeight id="fabrication-info-panel" duration={500} height={height}>
          <p className="m-0">
            To get an online PCB Fabrication quote simply fill out the following form
            and click on the QUOTE button.
            <br />
            Our system will automatically display two quotes, one for boards fabricated
            in the USA and one for boards made in China.
            <br />
            During the checkout process you determine if the bare boards will ship
            directly
            to you or to out PCB Assembly facility in Oregon.
            <br />
            The transit time for offshore PCBs (e.i China to the USA) is usually 2
            business
            days.
          </p>
        </AnimateHeight>
      </div>
    </div>
  );
};

InfoFabrication.propTypes = {
  showSummary: Proptypes.bool.isRequired,
}

export default InfoFabrication
